import { atom } from 'recoil'
import { ImportedUser } from 'src/apis/management/user'
import { ManagementRegistration } from 'src/types/management/form'
import { ManagementTutorialCategory } from 'src/types/management'

const bulkInsertNewUserRecordsState = atom({
  key: 'managementBulkInsertNewUserRecords',
  default: [] as ImportedUser[]
})

const bulkInsertFailureUserRecordsState = atom({
  key: 'managementBulkInsertFailureUserRecords',
  default: null as any
})

const formUserDataCsvState = atom({
  key: 'managementFormUserDataCsv',
  default: null as any
})

const managementRegistrationState = atom<ManagementRegistration>({
  key: 'managementRegistrationData',
  default: {
    companyName: '',
    name: '',
    email: ''
  }
})

const managementTutorialState = atom<ManagementTutorialCategory[]>({
  key: 'managementTutorialData',
  default: []
})

const managementSelectedTutorialState = atom<number | null>({
  key: 'managementSelectedTutorialData',
  default: null
})

const managementTutorialFirstFinishedState = atom<boolean>({
  key: 'managementTutorialFirstFinishedData',
  default: false
})

const managementUserCount = atom({
  key: 'managementUserCountData',
  default: 0
})

const managementAuthorityShow = atom({
  key: 'managementAuthorityShowData',
  default: false
})

const managementAuthorityMessage = atom({
  key: 'managementAuthorityMessageData',
  default: ''
})

const managementAuthorityTitle = atom({
  key: 'managementAuthorityTitleData',
  default: ''
})

export {
  bulkInsertNewUserRecordsState,
  bulkInsertFailureUserRecordsState,
  formUserDataCsvState,
  managementRegistrationState,
  managementTutorialState,
  managementSelectedTutorialState,
  managementTutorialFirstFinishedState,
  managementUserCount,
  managementAuthorityShow,
  managementAuthorityMessage,
  managementAuthorityTitle
}
